import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { ButtonDirective } from '../../directives/button.directive';
import { ScreenSizeService } from '../../../services/screen-size.service';
import { PhoneHeaderComponent } from '../phone-header/phone-header.component';

/** Stands in for a page the current size does not support (design.md § 7 "Admin sizes"). */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-size-message',
  standalone: true,
  imports: [RouterLink, TranslocoDirective, ButtonDirective, PhoneHeaderComponent],
  template: `
    <ng-container *transloco="let t">
      @if (isPhone()) {
        <!-- The shell hides the top bar on a phone, so without this header the message page has no sign out and no help. -->
        <app-phone-header />
      }
      <div class="mx-auto flex max-w-110 flex-col items-center gap-4 py-12 text-center">
        <h1 class="text-heading-md" tabindex="-1">{{ t(messageKey()) }}</h1>
        <a appButton="primary" routerLink="/today">{{ t('sizeMessage.goToToday') }}</a>
      </div>
    </ng-container>
  `,
})
export class SizeMessageComponent {
  private readonly _size = inject(ScreenSizeService).size;

  protected readonly isPhone = computed(() => this._size() === 'phone');
  // The tablet only lacks Settings.
  protected readonly messageKey = computed(() => (this.isPhone() ? 'sizeMessage.phone' : 'sizeMessage.tabletSettings'));
}
